import { useEffect } from 'react';

import {
  AuthErrorType,
  AuthenticationState,
  isMaybeFirebaseError,
  isSignInWithEmailLink,
  readEmailLinkInternalErrorReason,
  signInWithEmailLink,
  useNavigateTo,
  LocalStorageKey,
  rememberMagicLinkLogin,
} from '@neo.tax/shared';

export const useEmailLink = (): void => {
  const navigateTo = useNavigateTo();

  useEffect(() => {
    const isSignInWithEmail = isSignInWithEmailLink();
    if (isSignInWithEmail) {
      const storedEmail = window.localStorage.getItem(LocalStorageKey.SESSION_ONBOARDING_EMAIL);
      if (storedEmail) {
        (async (): Promise<void> => {
          try {
            await signInWithEmailLink(storedEmail);
            // Firebase reports magic-link and email/password logins identically as
            // sign_in_provider 'password'. Remember (briefly) that this was a magic-link sign-in so
            // authLink can stamp the x-login-method header and the server's auth guard records it as
            // MAGIC_LINK rather than EMAIL_PASSWORD.
            rememberMagicLinkLogin();
          } catch (error) {
            // `auth/internal-error` needs to find its reason from the error's message; anything else is a
            // bad link.
            AuthenticationState.updateAuthErrorType(
              isMaybeFirebaseError(error) && error.code === 'auth/internal-error'
                ? readEmailLinkInternalErrorReason(error.message)
                : AuthErrorType.LOGIN_LINK_ERROR,
            );
            navigateTo('/login');
          }
        })();
      } else {
        AuthenticationState.updateAuthErrorType(AuthErrorType.MISSING_EMAIL_IN_LOGIN_LINK);
      }
    }
  }, [navigateTo]);
};
